import { ReaderAuthDialog } from '../components/ReaderAuthDialog';

export default function LoginPage() {
  return <ReaderAuthDialog />;
}
